var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg",staticStyle:{"background-image":"url('images/bg.svg')"}})
}
var staticRenderFns = []

export { render, staticRenderFns }